import ShSlider from './src/main.vue'
ShSlider.install = function (Vue) {
  Vue.component(ShSlider.name, ShSlider)
}
export default ShSlider
